import React from 'react';
import { color } from 'theme';

export const NextArrowIcon = ({ fill = color.red }) => (
  <svg
    preserveAspectRatio="xMidYMid meet"
    style={{ width: '100%', height: '100%' }}
    viewBox="0 0 58 180"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M 13 15 L 45 90 L 13 165"
      fill="none"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
  </svg>
);

// TWEAKING GUIDE:
// strokeWidth: 2.5 = thickness (try 2-4)
// Path coordinates: "M 20 60 L 40 125 L 20 190"
//   - First number (20): horizontal position of arrow tips (higher = more right)
//   - Second/Fourth numbers (60, 190): vertical start/end (closer = shorter arrow)
//   - Middle (40, 125): arrow point position (higher = sharper angle)
